import React from 'react';
import {CardText} from 'material-ui/Card';
import {List, ListItem} from 'material-ui/List';
import Avatar from 'material-ui/Avatar';
import md5 from 'js-md5';
import moment from 'moment';
import FlatButton from 'material-ui/FlatButton';
import NextIcon from 'material-ui/svg-icons/navigation/chevron-right';
import PrevIcon from 'material-ui/svg-icons/navigation/chevron-left';
import DeleteIcon from 'material-ui/svg-icons/action/delete';
import LinearProgress from 'material-ui/LinearProgress';
import { makeTitle } from '../reducer';

class RecentResponseList extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {
    let { responses, fetching, min, max, hasNext, onNext, onPrevious, userEmail } = this.props;
    return (
      <div>
        <CardText style={{textAlign: "center"}}>
          <FlatButton
            disabled={min === 1 || fetching}
            icon={<PrevIcon />}
            labelPosition="after"
            onClick={onPrevious}
            label="Newer" />
          &nbsp; Showing {min} - {max} &nbsp;
          <FlatButton
            labelPosition="before"
            onClick={onNext}
            disabled={!hasNext || fetching}
            label="Older"
            icon={<NextIcon />} />
        </CardText>
        { fetching ? <LinearProgress mode="indeterminate" /> : null }
        <List>
          {
            responses.map((response) => {
              return <ListItem
                onClick={this.props.onClick.bind(null, response)}
                leftAvatar={<Avatar src={`https://www.gravatar.com/avatar/${md5(response.email)}?d=mm`} />}
                key={response.metadata.id}
                primaryText={response.name}
                secondaryText={<span>{`${makeTitle(response)}`}<em>{ response.context ? ` - ${response.context}` : ""}</em></span>}
                rightIcon={
                  <div style={{width: 'auto', color: "grey", fontWeight: 'lighter'}}>
                    <span>
                      {moment(response.metadata.createdAt).fromNow()}
                    </span>
                    {response.email === userEmail ? <DeleteIcon onClick={this.props.onDeleteClick.bind(this, response)}/> : null}
                  </div>
                } />
            })
          }
        </List>
      </div>
    )
  }
}


export default RecentResponseList;
